/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TrialUserGarbageCollectionParams } from './trialUserGarbageCollectionParams';

/**
 * Request model for trial user garbage collection job
 */
export interface RunTrialUserGarbageCollectionJobRequest {
  type: 'trial_user_garbage_collection';
  params: TrialUserGarbageCollectionParams;
  allowOverlappingJobs?: boolean;
}
